import CostCalculator from './costCalculator';

export default [CostCalculator];
